import styled from "styled-components";

const Tabela = styled.table`
    width: 90%;
    justify-content: left;
    text-align: center;
    border-collapse: collapse;
    margin: auto;
    margin-top: 10px;
    overflow-x: auto;
`
const LinhaTabela = styled.tr`
    border-bottom: ${props => props.$bordaBaixo || "1px solid lightgray"};
    border-top: ${props => props.$bordaTopo || "none"};
    height: 30px;
    background-color: ${props => props.$corFundo || "transparent"};
`
const ColunaTabela = styled.td`
    width: ${props => props.$tamanho || "auto"};
    color: #252525;
    font-weight: ${props => props.$bold || "normal"};
`

// Variável com os tipos de ingressos a serem mostrados na tabela
const tiposIngressos = [
    { tipo: "individuais", label: "Individuais" },
    { tipo: "promocionaisExcursao", label: "Excursão" },
    { tipo: "promocionaisEscolar", label: "Escolar"},
    { tipo: "individuaisOnline", label: "Individuais online"},
    { tipo: "infantis", label: "Infantis" },
    { tipo: "infantisOnline", label: "Infantis online" },
    { tipo: "cortesias", label: "Cortesias" },
    { tipo: "parksnet", label: "PARKSNET" },
    { tipo: "promocionais", label: "Promocionais" },
    { tipo: "promocionaisOnline", label: "Promocionais online" }
];

export function TabelaTotais(quantidades) {
    const qtdeTotal = tiposIngressos.reduce( (total, item) => total + quantidades[item.tipo], 0);
    
    try {
        return (
            <Tabela>
                <tbody>
                    {tiposIngressos.map( tipo => {
                        return (<LinhaTabela $bordaTopo="1px solid lightgray">
                            <ColunaTabela $bold="bold" $tamanho="200px">{tipo.label}</ColunaTabela>
                            <ColunaTabela>{quantidades[tipo.tipo] || 0}</ColunaTabela>
                        </LinhaTabela>)
                    })}
                    <LinhaTabela> 
                        <ColunaTabela $bold="bold" $tamanho="200px">TOTAL</ColunaTabela>
                        <ColunaTabela>{qtdeTotal || "-"}</ColunaTabela>
                    </LinhaTabela>
                </tbody>
            </Tabela>
        );
    } catch (e) {
        return <></>
    }
}